import React, { useState, useContext, useEffect } from "react";
import { TableCell, TableRow } from "@mui/material";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import FieldText from "./../../../../common/component/form/FieldText";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Files from "react-files";
import TableScrollDiv from "../../../../common/component/table/TableScrollDiv";
import useForm from "../../../../common/hooks/useForm";
import useAutoComplete from "../../../../common/hooks/useAutoComplete";
import { path } from "../../../../constants/apiPath";
import FieldAutoComplete from "../../../../common/component/form/FieldAutoComplete";
import { useNavigate, useLocation } from "react-router-dom";
import DocumentSVG from "../../../../svg/svg-body/DocumentSVG";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { StoreContext } from "../../../../store";
import DeleteIcon from "@mui/icons-material/Delete";
import instance from "../../../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import routeConstant from "../../../../../route/compoent/routeConstant";
import Loading from "../../../loading/Loading";
import { StoreContext as OmsStore } from "../../../../../store/Provider";

function EditDocUpload() {
  const documentOrderNumber = useForm();
  const docType = useAutoComplete(path.GET_DOC_TYPE);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const location = useLocation();
  const [edit, setEdit] = useState(false);
  const { omsUserData } = useContext(OmsStore);

  const [docDataList, setDocDataList] = useState([]);
  const [inputDisabled, setInputDisabled] = useState(false);

  useEffect(() => {
    if (!location.state) {
      if (location.pathname.includes(routeConstant.ORDER_LIST)) {
        navigate(routeConstant.ORDER_LIST_PLACED, { replace: true });
      } else if (location.pathname.includes(routeConstant.ORDER_DASHBOARD)) {
        navigate(routeConstant.ORDER_DASHBOARD, { replace: true });
      }
    } else {
      const arr = location?.state?.editOrderJSON.OrderDocumentsCollection
        ? [...(location?.state?.editOrderJSON.OrderDocumentsCollection ?? [])]
        : [];

      setDocDataList([...arr]);
      const IsOrderDocumentEditable =
        location?.state?.editOrderJSON.OrderHeader.IsOrderDocumentEditable;
      const disabled =
        omsUserData.UserRoles.includes("Supplier") && !IsOrderDocumentEditable
          ? true
          : !context.orderUserAccess?.EditOrderDocument;
      setInputDisabled(disabled);
    }
  }, []);

  const onFilesChange = (files) => {
    setFiles(files);
    if (!documentOrderNumber.value) {
      documentOrderNumber.setValue(files[0]?.name);
    }
    files.length !== 0 && setFileError("");
  };
  const onfileRemove = () => {
    documentOrderNumber.setValue("");
    setFiles([]);
  };
  const onDocUpload = async () => {
    documentOrderNumber.setValue("");
    if (files.length && docType.value) {
      const getBase64 = async (file, onLoadCallback) => {
        return await new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      let DocsFileConversion = "";
      var promise = getBase64(files[0]);
      promise.then((result) => {
        DocsFileConversion = `${result.split(";base64,")[0]};base64,`;
        let data = result.split(";base64,")[1];
        let filesizeUnit = files[0].sizeReadable.substr(-2);
        let fileSize = files[0].sizeReadable.split(
          files[0].sizeReadable.substr(-2)
        )[0];
        console.log("docDataList", docDataList);
        // setDocDataList([
        //   ...docDataList,
        const docue = {
          DocsPk: "",
          DocsFk: location.state.editOrderJSON.OrderHeader.OrderPK,
          DocsDocType: docType.value.Code,
          docTypeDesc: docType.value.Description,
          DocsFileName: documentOrderNumber.value
            ? documentOrderNumber.value
            : files[0].name,
          DocsFileSize: fileSize,
          DocsFileSizeUnit: filesizeUnit,
          DocsUploadedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
          DocsUploadedBY: context.userData.FullName ?? "",
          DocsFileData: data,
          DocsFileExtention: files[0].extension,
          DocsFileConversion: DocsFileConversion,
        };

        uploadDocuments(docue);
        // ]);
      });
    }
    setFiles([]);
  };

  const uploadDocuments = (doc) => {
    instance
      .post(path.DOCUMENT_UPLOAD, doc)
      .then((res) => {
        setDocDataList(res.data ?? []);
      })
      .catch((err) => {});
  };
  const onFilesError = (error, file) => {
    NotificationManager.error(error.message, "", 3000);
    setFileError(`Error code ${error.code} : ${error.message}.`);
  };
  const column = [
    "Sr. No",
    "Doc Type",
    "Doc Name",
    "Doc Size",
    "Uploaded On",
    "Uploaded By",
    "Download",
    "Delete",
  ];

  const onNextHandler = (path) => {
    const arr = [];

    docDataList.map((ele, index) => {
      const item = {};
      const data = {
        ...ele,
        DocsFileName: ele.DocsFileName,
        DocsFileData: ele.DocsFileData,
        DocsFileExtention: ele.DocsFileExtention,
        DocsDocType: ele.DocsDocType,
        DocsFileSize: ele.DocsFileSize,
        DocsFileSizeUnit: ele.DocsFileSizeUnit,
        DocsUploadedBY: ele.DocsUploadedBY,
        DocsUploadedDate: ele.DocsUploadedDate,
        DocsFileConversion: ele.DocsFileConversion,
      };
      arr.push({ ...data });
    });
    const body = {
      ...location.state.editOrderJSON,
      OrderDocumentsCollection: [...arr],
      OrderNotesCollection: [],
    };
    context.setEditOrderJSON({
      ...body,
    });
    navigate(path, {
      state: { edit: edit, editOrderJSON: body },
    });
  };

  // const onPostOrder = (route, body) => {
  //   instance
  //     .post(path.POST_ORDER, body)
  //     .then((res) => {
  //       navigate(route);
  //     })
  //     .catch((err) => {});
  // };

  const onDocDelete = (ele, index) => {
    let arr = docDataList;

    if (ele.DocsPk) {
      const url = `${path.DELETE_DOCUMENTS}?orderPK=${location.state.editOrderJSON.OrderHeader.OrderPK}&documentPK=${ele.DocsPk}`;
      instance
        .delete(url)
        .then((res) => {
          arr.splice(index, 1);
          setDocDataList([...arr]);
          context.setEditOrderJSON({
            ...location.state.editOrderJSON,
            OrderDocumentsCollection: [...arr],
          });

          if (res.Is_Success) {
            NotificationManager.success(res.Message, "", 3000);
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      arr.splice(index, 1);
      setDocDataList([...arr]);
    }
  };

  const onDocumentDownload = (ele) => {
    // ${location.state.editOrderJSON.OrderHeader.OrderPK}

    context.setBackDropOpen(true);
    if (ele.DocsPk) {
      const url = `${path.DOWNLOAD_DOCUMENTS}?orderPK=${ele.DocsFk}
      &documentPK=${ele.DocsPk}`;
      instance
        .get(url)
        .then((res) => {
          if (res.Is_Success) {
            const a = document.createElement("a");

            a.href = `${res.data.DocsFileConversion}${res.data.DocsFileData}`;
            a.target = "_blank";
            a.download = ele.DocsFileName;
            a.name = ele.DocsFileName ?? "document";
            a.click();

            context.setBackDropOpen(false);
            NotificationManager.success(res.Message, "", 3000);
          } else {
            context.setBackDropOpen(false);
            NotificationManager.error(res.Message, "", 3000);
          }
        })
        .catch((err) => {
          console.error(err);
          context.setBackDropOpen(false);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
        });
    } else {
      const a = document.createElement("a");

      a.href = `${ele.DocsFileConversion}${ele.DocsFileData}`;
      a.target = "_blank";
      a.download = ele.DocsFileName;
      a.name = ele.DocsFileName;
    }
  };

  if (!location.state) return <Loading />;

  return (
    <LayoutCreateOrder
      onNextHandler={onNextHandler}
      title="Edit Order"
      editComp={true}
    >
      <div className="_orderDocUpload">
        <div className="container-fluid">
          <div className="row">
            <div className=" col-12 _orderDocDetails">
              <div className="row">
                <div className="col-md-4 col-12 _orderUploadDoc">
                  <h5>Upload E-Docs</h5>
                  <FieldAutoComplete
                    label="Document Type"
                    item="Description"
                    disabled={inputDisabled}
                    value={docType.value}
                    onChange={docType.onChange}
                    error={docType.error}
                    errorMsg={docType.errorMsg}
                    options={docType.options}
                  />
                  <FieldText
                    label="Document Name"
                    disabled={inputDisabled}
                    value={documentOrderNumber.value}
                    onChange={documentOrderNumber.onChange}
                    error={documentOrderNumber.error}
                    errorMsg={documentOrderNumber.errorMsg}
                  />
                  {files.length === 0 ? (
                    <Files
                      className="files-dropzone"
                      dragActiveClassName="files-dropzone-active"
                      onChange={onFilesChange}
                      onError={onFilesError}
                      accepts={[".pdf", ".docx", ".xlsx", ".xls", ".csv"]}
                      maxFileSize={1024000}
                      minFileSize={0}
                      clickable={!inputDisabled}
                      multiple={false}
                      disabled={inputDisabled}
                    >
                      <CloudUploadOutlinedIcon />
                      <p>Drag and Drop Docs Here</p>
                      <span>or</span>
                      <p>Click here to browse Docs</p>
                      <p className="_filemaxInfo">
                        Max. File size should be less than 1MB
                      </p>
                    </Files>
                  ) : (
                    <div>
                      <div className="files-dropzone">
                        <div className="_documentShow">
                          {files.map((items) => {
                            return (
                              <div
                                className={`_uploadDoc ${items.id}`}
                                key={items.id}
                              >
                                <DocumentSVG colorCode={"#438bc3"} />
                                <p title={items.name}>{items.name}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row justify-content-between my-2">
                    <div className="_outlineButton w-auto">
                      <button
                        disabled={inputDisabled}
                        className="w-auto"
                        onClick={onfileRemove}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="_solidButton w-auto">
                      <button
                        disabled={inputDisabled}
                        className="w-auto"
                        onClick={onDocUpload}
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-12 _orderDocList">
                  <h5>Document List</h5>
                  <TableScrollDiv className="_orderLineTable" column={column}>
                    {docDataList.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={column.length}>
                          No Doc Uploaded
                        </TableCell>
                      </TableRow>
                    ) : (
                      docDataList.map((ele, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{ele.DocsDocType}</TableCell>
                            <TableCell>{ele.DocsFileName}</TableCell>
                            <TableCell>{`${ele.DocsFileSize} ${ele.DocsFileSizeUnit}`}</TableCell>
                            <TableCell>
                              {ele.DocsUploadedDate.split(" ")[0]}
                            </TableCell>
                            <TableCell>{ele.DocsUploadedBY}</TableCell>
                            <TableCell>
                              <a
                                className="_orderlineDocDownloadAnchor"
                                onClick={() => {
                                  onDocumentDownload(ele);
                                }}
                              >
                                <DownloadIcon />
                              </a>
                            </TableCell>
                            <TableCell>
                              <button
                                disabled={
                                  !context.orderUserAccess?.DeleteOrderDocument
                                }
                                className="_orderLineDeleteRow"
                                onClick={() => {
                                  onDocDelete(ele, index);
                                }}
                              >
                                <DeleteIcon />
                              </button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableScrollDiv>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutCreateOrder>
  );
}

export default EditDocUpload;
